import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { IoFlash } from 'react-icons/io5';
import { MdPhone, MdCheckCircle } from 'react-icons/md';
import { BsHouseFill, BsBuilding, BsShieldFillCheck, BsTools } from 'react-icons/bs';
import { GiElectric } from 'react-icons/gi';
import { FiArrowRight, FiTool } from 'react-icons/fi';

const services = [
  {
    Icon: BsHouseFill,
    title: 'Home Wiring & Rewiring',
    desc: 'Complete house wiring for new constructions and full rewiring of older buildings using ISI-certified FR wires, conduits, and switchgear.',
    features: ['Site survey & BOM preparation','ISI certified materials supplied','DB panel installation','3-year workmanship warranty'],
  },
  {
    Icon: BsBuilding,
    title: 'Industrial & Commercial Wiring',
    desc: 'Electrical wiring for factories, offices, and commercial spaces — including panel rooms, heavy cable laying, and conduit installations.',
    features: ['Armoured cable laying','DB & MCC panel erection','Motor & drive wiring','Load balancing & earthing'],
  },
  {
    Icon: FiTool,
    title: 'Conduit & Trunking Work',
    desc: 'Professional installation of PVC conduit pipes, flexible conduits, junction boxes, and complete concealed and surface conduit systems.',
    features: ['Concealed & surface conduit','Flexible pipe for slabs','Junction box installation','Cable tray & trunking'],
  },
  {
    Icon: BsTools,
    title: 'Switchgear & Panel Work',
    desc: 'Supply and installation of distribution boards, MCBs, RCCBs, isolators, and busbars for safe and compliant electrical panels.',
    features: ['DB box supply & fitting','MCB / RCCB installation','Main switch & isolator','Panel testing & sign-off'],
  },
  {
    Icon: GiElectric,
    title: 'Earthing Systems',
    desc: 'Design and installation of conventional and chemical earthing systems for homes, commercial premises, and industrial plants.',
    features: ['Copper & GI electrode pits','Chemical earthing compound','Earthing wire & bonds','Earth resistance testing'],
  },
  {
    Icon: BsShieldFillCheck,
    title: 'Electrical Safety Audit',
    desc: 'Inspection of existing wiring, switchgear, and earthing to identify hazards, compliance gaps, and worn-out materials.',
    features: ['Full installation inspection','Earthing & insulation test','Written report & recommendations','Insurance compliance support'],
  },
];

const process = [
  { step:'01', title:'Enquiry',   desc:'Call us or fill the contact form. We respond within 2 hours on working days.' },
  { step:'02', title:'Site Visit', desc:'Our engineer visits for a free assessment and material quantity survey.' },
  { step:'03', title:'Proposal',  desc:'You receive a detailed scope-of-work, material list, and cost estimate.' },
  { step:'04', title:'Execution', desc:'Skilled team executes the work on your schedule with ISI-certified materials.' },
  { step:'05', title:'Handover',  desc:'Final testing, sign-off, and warranty documentation handed over to you.' },
];

export default function Services() {
  return (
    <div className="page-wrapper">

      <section className="page-hero bg-grid">
        <div className="page-hero-inner container">
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <span className="breadcrumb-sep">›</span>
            <span>Services</span>
          </div>
          <div className="tag"><span className="tag-dot" />What We Do</div>
          <h1 className="page-hero-title">OUR <span>SERVICES</span></h1>
          <p className="page-hero-desc">
            End-to-end electrical solutions — supply of ISI-certified wiring materials plus expert installation by certified professionals.
          </p>
          <div className="page-hero-line" />
        </div>
        <div className="page-hero-bg-text">SERVICES</div>
      </section>

      {/* Services Grid */}
      <section className="section">
        <div className="container">
          <div className="section-header" style={{ textAlign:'center' }}>
            <div className="section-subtitle">Expertise</div>
            <h2 className="section-title">EVERYTHING <span>ELECTRICAL</span></h2>
          </div>
          <div className="services-grid">
            {services.map((s, i) => (
              <div className="service-card" key={i} style={{ animationDelay:`${i*0.1}s` }}>
                <div className="service-icon-wrap">
                  <div className="service-icon">
                    <s.Icon />
                  </div>
                  <div className="service-icon-ring" />
                </div>
                <div className="service-title">{s.title}</div>
                <p className="service-desc">{s.desc}</p>
                <div className="service-features">
                  {s.features.map((f, j) => (
                    <div className="service-feature" key={j}>
                      <MdCheckCircle />
                      {f}
                    </div>
                  ))}
                </div>
                <div style={{ marginTop:22 }}>
                  <Link to="/contact" className="btn-outline btn-sm" style={{ fontSize:'.82rem', padding:'9px 20px' }}>
                    Get Quote <FiArrowRight />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="section section--dark-alt">
        <div className="container">
          <div className="section-header" style={{ textAlign:'center' }}>
            <div className="section-subtitle">Simple Process</div>
            <h2 className="section-title">HOW IT <span>WORKS</span></h2>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(180px,1fr))', gap:'22px', position:'relative' }}>
            {process.map((p, i) => (
              <div key={i} style={{
                textAlign:'center', padding:'32px 18px',
                background:'var(--card-bg)', border:'1px solid var(--card-border)',
                borderRadius:'var(--radius-lg)', position:'relative',
                opacity:0, animation:`fadeInUp 0.6s ease ${i*0.1}s forwards`,
                transition:'var(--transition)',
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor='var(--card-border-h)'; e.currentTarget.style.transform='translateY(-5px)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor='var(--card-border)'; e.currentTarget.style.transform='translateY(0)'; }}
              >
                <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:'3.2rem', color:'rgba(245,166,35,.15)', lineHeight:1, marginBottom:12 }}>{p.step}</div>
                <div style={{ fontFamily:"'Rajdhani',sans-serif", fontWeight:700, fontSize:'1.05rem', marginBottom:8, color:'var(--white)' }}>{p.title}</div>
                <p style={{ fontSize:'.84rem', color:'var(--gray-400)', lineHeight:1.65 }}>{p.desc}</p>
                {i < process.length-1 && (
                  <div style={{ position:'absolute', right:'-12px', top:'50%', transform:'translateY(-50%)', color:'var(--primary)', fontSize:'1.5rem', zIndex:1 }}>
                    <FiArrowRight />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <h2 className="cta-title">NEED A SERVICE <span style={{ color:'var(--primary)' }}>QUOTE?</span></h2>
          <p className="cta-desc">Get a free on-site estimate from our certified electrical engineers today.</p>
          <div className="cta-actions">
            <Link to="/contact" className="btn-primary"><IoFlash /> Book a Site Visit</Link>
            <a href="tel:+919876543210" className="btn-outline"><MdPhone /> Call Now</a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}